import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { NotificationModel } from '../components/notification/notificationModel.interface';
import { CustomHttpParams } from './custom-http-params.class';

@Injectable()
export class CommonService {
  notificationEvent = new BehaviorSubject<NotificationModel>({
    key: '',
    severity: '',
    summary: '',
    detail: '',
  });
  notificationEv$ = this.notificationEvent.asObservable();

  constructor(private http: HttpClient) {}

  private handleError(error: Response | any): any {
    const errorMsg: string = 'Error';

    return throwError(() => error);
  }

  public postVerb<T>(
    endpoint: string,
    data: any,
    loaderUse?: boolean,
    customParams?,
  ): Observable<T | any> {
    const httpType: boolean = _.isUndefined(loaderUse) ? true : loaderUse;
    const params = customParams
      ? Object.assign(new CustomHttpParams(httpType), customParams)
      : new CustomHttpParams(httpType);
    return this.http
      .post<T>(endpoint, data, { params })
      .pipe(catchError(this.handleError));
  }

  public putVerb<T>(
    endpoint: string,
    data: any,
    loaderUse?: boolean,
  ): Observable<T | any> {
    const httpType: boolean = _.isUndefined(loaderUse) ? true : loaderUse;

    return this.http
      .put<T>(endpoint, data, { params: new CustomHttpParams(httpType) })
      .pipe(catchError(this.handleError));
  }

  public patchVerb<T>(
    endpoint: string,
    data: any,
    loaderUse?: boolean,
  ): Observable<T | any> {
    const httpType: boolean = _.isUndefined(loaderUse) ? true : loaderUse;
    const options: any = { params: new CustomHttpParams(httpType), responseType: 'text' };
    return this.http.patch<T>(endpoint, data, options).pipe(catchError(this.handleError));
  }

  public getVerb<T>(
    endpoint: string,
    loaderUse?: boolean,
    customParams?,
  ): Observable<T | any> {
    const httpType: boolean = _.isUndefined(loaderUse) ? true : loaderUse;
    const params = customParams
      ? Object.assign(new CustomHttpParams(httpType), customParams)
      : new CustomHttpParams(httpType);
    return this.http.get<T>(endpoint, { params }).pipe(catchError(this.handleError));
  }

  public getPlainTextVerb(endpoint: string, loaderUse?: boolean): Observable<any> {
    const httpType: boolean = _.isUndefined(loaderUse) ? true : loaderUse;
    return this.http.get(endpoint, { observe: 'response' });
  }

  public getVerbFiles<T>(endpoint: string, loaderUse?: boolean): Observable<T | any> {
    const httpType: boolean = _.isUndefined(loaderUse) ? true : loaderUse;

    return this.http
      .get<T>(endpoint, { responseType: 'blob' as 'json' })
      .pipe(catchError(this.handleError));
  }

  public deleteVerb<T>(endpoint: string, loaderUse?: boolean): Observable<T | any> {
    const httpType: boolean = _.isUndefined(loaderUse) ? true : loaderUse;

    return this.http
      .delete<T>(endpoint, { params: new CustomHttpParams(httpType) })
      .pipe(catchError(this.handleError));
  }

  public sendNotification(data: NotificationModel) {
    this.notificationEvent.next(data);
  }
}
